import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { GradeForm } from './GradeForm';

export function EditGradeDialog({ 
  open, 
  onOpenChange, 
  editingGrade,
  sharedData, 
  setSharedData, 
  gradeForms, 
  disciplines, 
  schedules, 
  figures, 
  dances,
  updateGradeForm,
  updateGradeFormGroup,
  formatFigureDisplay,
  handleEditSubmit,
  resetAddForm,
  setEditingGrade,
  currentUser,
  onTimingChange,
  readOnly = false,
}) {
  return (
    <Dialog open={open} onOpenChange={(val) => { onOpenChange(val); if (!val) { setEditingGrade(null); resetAddForm(); } }}>
      <DialogContent className="max-h-[90vh] overflow-y-auto overflow-x-hidden" style={{ maxWidth: '640px', width: '640px' }}>
        <DialogHeader>
          <DialogTitle>{readOnly ? 'View Grade' : 'Edit Grade'}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleEditSubmit} className="w-full max-w-full overflow-hidden">
          <fieldset disabled={readOnly} className="contents">
          {/* Discipline and Schedule (stacked in edit mode) */}
          <div className="mb-4 p-4 bg-stone-100 rounded-lg space-y-3">
            <div>
              <Label>Discipline</Label>
              <select 
                className="w-full border rounded-lg px-3 py-2 mt-1"
                value={sharedData.discipline_id}
                onChange={(e) => setSharedData({...sharedData, discipline_id: e.target.value})}
              >
                <option value="">Select Discipline</option>
                {disciplines.map(d => (
                  <option key={d.discipline_id} value={d.discipline_id}>{d.discipline}</option>
                ))}
              </select>
            </div>
            <div>
              <Label>Schedule</Label>
              <select 
                className="w-full border rounded-lg px-3 py-2 mt-1"
                value={sharedData.schedule_id}
                onChange={(e) => setSharedData({...sharedData, schedule_id: e.target.value})}
              >
                <option value="">Select Schedule</option>
                {schedules.map(s => (
                  <option key={s.schedule_id} value={s.schedule_id}>{s.schedule_type}</option>
                ))}
              </select>
            </div>
          </div>
          
          <div className="w-full max-w-full">
            {gradeForms.length > 0 && (
              <GradeForm 
                form={gradeForms[0]}
                index={0}
                isEditMode={true}
                disciplines={disciplines}
                figures={figures}
                dances={dances}
                sharedData={sharedData}
                updateGradeForm={updateGradeForm}
                updateGradeFormGroup={updateGradeFormGroup}
                formatFigureDisplay={formatFigureDisplay}
                schedules={schedules}
                currentUser={currentUser}
                onTimingChange={onTimingChange}
              />
            )}
          </div>
          </fieldset>
          
          {!readOnly && (
            <div className="mt-6 flex gap-3">
              <Button type="submit" className="flex-1 btn-primary">
                Update Grade
              </Button>
              <Button 
                type="button" 
                onClick={(e) => handleEditSubmit(e, true)}
                variant="outline"
                className="flex-1"
              >
                Update Grade, Edit Next
              </Button>
            </div>
          )}
        </form>
      </DialogContent>
    </Dialog>
  );
}
